/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BasicPageantDTOPagedResult,
  BooleanResponseWrapper,
  EventBaseModel,
  EventMetadataModelResponseWrapper,
  EventModel,
  EventModelIEnumerableResponseWrapper,
  EventModelResponseWrapper,
  TemporalFilter,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Event<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventById
   * @request GET:/Event/GetEventById:{eventId}
   */
  getEventById = (eventId: number, params: RequestParams = {}) =>
    this.request<EventModelResponseWrapper, any>({
      path: `/Event/GetEventById:${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name DetailsDetail
   * @request GET:/Event/{eventId}/{eventName}/details
   */
  detailsDetail = (eventId: number, eventName: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Event/${eventId}/${eventName}/details`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventMetadata
   * @request GET:/Event/GetEventMetadata:{eventId}
   */
  getEventMetadata = (eventId: number, params: RequestParams = {}) =>
    this.request<EventMetadataModelResponseWrapper, any>({
      path: `/Event/GetEventMetadata:${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventMetadataByPageantId
   * @request GET:/Event/GetEventMetadataByPageantId:{pageantId}
   */
  getEventMetadataByPageantId = (pageantId: number, params: RequestParams = {}) =>
    this.request<EventMetadataModelResponseWrapper, any>({
      path: `/Event/GetEventMetadataByPageantId:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllFutureEvents
   * @request GET:/Event/GetAllFutureEvents
   */
  getAllFutureEvents = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetAllFutureEvents`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetFutureFeaturedEvents
   * @request GET:/Event/GetFutureFeaturedEvents
   */
  getFutureFeaturedEvents = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetFutureFeaturedEvents`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetTotalFutureEventsCount
   * @request GET:/Event/GetTotalFutureEventsCount
   */
  getTotalFutureEventsCount = (params: RequestParams = {}) =>
    this.request<number, any>({
      path: `/Event/GetTotalFutureEventsCount`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetTotalPastEventsCount
   * @request GET:/Event/GetTotalPastEventsCount
   */
  getTotalPastEventsCount = (params: RequestParams = {}) =>
    this.request<number, any>({
      path: `/Event/GetTotalPastEventsCount`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetTotalCurrentEventsCount
   * @request GET:/Event/GetTotalCurrentEventsCount
   */
  getTotalCurrentEventsCount = (params: RequestParams = {}) =>
    this.request<number, any>({
      path: `/Event/GetTotalCurrentEventsCount`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetBasicEventsDynamic
   * @request GET:/Event/GetBasicEventsDynamic
   */
  getBasicEventsDynamic = (
    query?: {
      when?: TemporalFilter;
      /** @format int32 */
      limit?: number;
      /** @format date-time */
      cursorDateUtc?: string;
      /** @format int32 */
      cursorEventId?: number;
      search?: string;
      /** @format int32 */
      stateId?: number;
      /** @format int32 */
      pageantId?: number;
      acceptingEntries?: boolean;
      includeMetadata?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<BasicPageantDTOPagedResult, any>({
      path: `/Event/GetBasicEventsDynamic`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllFutureEventsSearchFilter
   * @request GET:/Event/GetFutureEventsSearchFilter
   */
  getAllFutureEventsSearchFilter = (
    query?: {
      /** @format int32 */
      page?: number;
      /** @format int32 */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetFutureEventsSearchFilter`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllPastEvents
   * @request GET:/Event/GetAllPastEvents
   */
  getAllPastEvents = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetAllPastEvents`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllFutureEventsBasicInfo
   * @request GET:/Event/GetFuture/GetAllFutureEventsBasicInfo
   */
  getAllFutureEventsBasicInfo = (params: RequestParams = {}) =>
    this.request<EventBaseModel, any>({
      path: `/Event/GetFuture/GetAllFutureEventsBasicInfo`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllFutureTrendingEvents
   * @request GET:/Event/GetAllFutureTrendingEvents
   */
  getAllFutureTrendingEvents = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetAllFutureTrendingEvents`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventsForBusiness
   * @request GET:/Event/GetEventsForBusiness
   */
  getEventsForBusiness = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/GetEventsForBusiness`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name SaveEvent
   * @request POST:/Event/Save
   */
  saveEvent = (data: EventModel, params: RequestParams = {}) =>
    this.request<EventModelResponseWrapper, any>({
      path: `/Event/Save`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name AddEvent
   * @request POST:/Event
   */
  addEvent = (data: EventBaseModel, params: RequestParams = {}) =>
    this.request<EventModelResponseWrapper, any>({
      path: `/Event`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name PatchEvent
   * @request PATCH:/Event
   */
  patchEvent = (data: EventBaseModel, params: RequestParams = {}) =>
    this.request<EventModelResponseWrapper, any>({
      path: `/Event`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name DeleteEvent
   * @request DELETE:/Event
   */
  deleteEvent = (
    query?: {
      /** @format int32 */
      eventId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/Event`,
      method: 'DELETE',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventByDirectorId
   * @request GET:/Event/ByDirector/GetEventByDirectorId:{directorId}
   */
  getEventByDirectorId = (directorId: number, params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/ByDirector/GetEventByDirectorId:${directorId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetEventsForDirectorDetail
   * @request GET:/Event/GetEventsForDirector/{userId}
   */
  getEventsForDirectorDetail = (userId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Event/GetEventsForDirector/${userId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name AssignDirectorUserIdToEventId
   * @request POST:/Event/{eventId}/assign-director/AssignDirectorUserIdToEventId:{directorUserId}
   */
  assignDirectorUserIdToEventId = (eventId: number, directorUserId: number, params: RequestParams = {}) =>
    this.request<EventModelResponseWrapper, any>({
      path: `/Event/${eventId}/assign-director/AssignDirectorUserIdToEventId:${directorUserId}`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventContoller
   * @name GetAllEventsForAdmin
   * @request GET:/Event/Admin/GetAllEventsForAdmin
   */
  getAllEventsForAdmin = (params: RequestParams = {}) =>
    this.request<EventModelIEnumerableResponseWrapper, any>({
      path: `/Event/Admin/GetAllEventsForAdmin`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
